import { ICustomer } from "~/apis/crm";
import { JobFormData, JobStep, ModalStep } from "./types/add-job.types";

const ADD_JOB_DRAFT_KEY = "cbr-add-job-draft";

export type AddJobDraft = {
  formData: JobFormData;
  modalStep: ModalStep;
  jobStep: JobStep;
  selectedContact: ICustomer[];
  customerAddress: string;
  useCustomerAddress: boolean;
};

export const readAddJobDraft = (): AddJobDraft | null => {
  try {
    const raw = sessionStorage.getItem(ADD_JOB_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const modalStep = parsed?.modalStep;
    const jobStep = parsed?.jobStep;
    if (
      !parsed?.formData ||
      (modalStep !== 1 && modalStep !== 2 && modalStep !== 3) ||
      (jobStep !== "Existing" && jobStep !== "New")
    ) {
      return null;
    }
    return {
      formData: parsed.formData,
      modalStep,
      jobStep,
      selectedContact: Array.isArray(parsed.selectedContact)
        ? parsed.selectedContact
        : [],
      customerAddress: parsed.customerAddress || "",
      useCustomerAddress: Boolean(parsed.useCustomerAddress),
    };
  } catch {
    return null;
  }
};

export const writeAddJobDraft = (draft: AddJobDraft) => {
  sessionStorage.setItem(ADD_JOB_DRAFT_KEY, JSON.stringify(draft));
};

export const clearAddJobDraft = () => {
  sessionStorage.removeItem(ADD_JOB_DRAFT_KEY);
};
